import React, { Component } from 'react';
import { withRedux } from '../hoc';

const mapStateToProps = state => {
  return state;
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class NotFound extends Component {
  render() {
    return <div className="notfound-page container-wrapper">NotFound</div>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/NotFound.js